<template>
  <div class="deviceRightCons">
    <div class="topWarp">
      <div class="title">
        <span>实时统计</span>
        <i class="img1"><img src="../../../assets/img/gateway/reset.png" alt=""></i>
        <i class="img2" title="更新数据" @click="resetDatas"><img src="../../../assets/img/gateway/resetOn.png" alt=""></i>
      </div>
      <div class="closeRight" @click="closeRightCons">
        <i><img src="../../../assets/img/gateway/closeRight.png" alt=""></i>
        <span>收起统计</span>
      </div>
    </div>
    <div class="top common">
      <ul>
        <li v-for="(tab,index) in statisticsList" :key="index">
          <div class="tabItem" :style="{'background':'url(' + (tab.imgBg?tab.imgBg:'none') + ') no-repeat','backgroundSize':'100% 100%'}">
            <div class="lCons">
              <div class="deviceImg">
                <img :src="tab.img" alt="">
              </div>
              <div class="lName" :title="tab.name">{{tab.name}}</div>
            </div>
            <div class="rCons">
              <div class="num">{{tab.num}}</div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="middle common">
      <div class="container">
        <h3>历史报警走势</h3>
        <div class="chartShow">
          <echarts ref="chartLine" v-loading="chartLoading" chart-id="chartLineId" :chart-option="options"></echarts>
        </div>
      </div>
    </div>
    <div class="bottom common">
      <div class="container">
        <h3>最新报警记录</h3>
        <div class="tBox">
          <div class="thTitle">
              <dl>
                <dd>序号</dd>
                <dd>设备名称</dd>
                <!-- <dd>设备IMEI</dd> -->
                <dd>报警内容</dd>
                <dd>安装位置</dd>
                <dd>报警时间</dd>
              </dl>
          </div>
          <vue-seamless-scroll :data="todayList" class="seamless-warp" :class-option="optionHover" v-if="todayList.length">
              <ul class="item">
                <li v-for="(item, index) in todayList" :key="index">
                    <span class="num">{{ index + 1 }}</span>
                    <span class="title" :title="item.deviceName" v-text="item.deviceName"></span>
                    <!-- <span class="title" :title="item.deviceIMEI" v-text="item.deviceIMEI"></span> -->
                    <span class="warnContent title" :title="item.content" v-text="item.content"></span>
                    <span class="title" :title="item.deviceInstallLocation" v-text="item.deviceInstallLocation"></span>
                    <span class="title" :title="item.createTime" v-text="item.createTime"></span>
                </li>
              </ul>
          </vue-seamless-scroll>
          <div class="noData" v-else><span>暂无数据</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  props: ['typeId'],
  watch: {
    typeId(newV) {
      // console.log(newV);
      // this.type=newV
      // this.getStatisticsList()
      // this.getHositoryEchart()
      // this.getTodayList()
    }
  },
  data(){
    return{
      options: {
        graphic: [{
          type: 'group',
          left: 'center',
          top: 'center',
          children: [{
            type: 'text',
            z: 100,
            left: 'center',
            top: 'middle',
            style: {
              fill: '#333',
              text: [''].join('\n'),
              font: '14px'
            }
          }]
        }],
        color: '#1089FF',
        // backgroundColor: '#0e1c47',
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#fff',
          axisPointer: {
            lineStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0,
                  color: 'rgba(126,199,255,0)' // 0% 处的颜色
                }, {
                  offset: 0.5,
                  color: 'rgba(126,199,255,1)' // 100% 处的颜色
                }, {
                  offset: 1,
                  color: 'rgba(126,199,255,0)' // 100% 处的颜色
                }],
                global: false // 缺省为 false
              }
            }
          }
        },
        grid: {
          top: '5%',
          left: '8%',
          // right: '10%',
          right: '5%',
          bottom: '10%'
          // containLabel: true
        },
        xAxis: [{
          // name: '日期',
          type: 'category',
          boundaryGap: true,
          // nameTextStyle: {
          //   color: '#0087ED'
          // },
          axisLine: { // 坐标轴轴线相关设置。数学上的x轴
            show: true,
            lineStyle: {
              // color: '#1089FF'
              color: 'rgba(16,137,255,0.1)'
            }
          },
          axisLabel: { // 坐标轴刻度标签的相关设置
            textStyle: {
              color: '#999B9E',
              padding: 0,
              fontSize: 12
            },
            formatter: function(data) {
              return data
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#192a4411'
            }
          },
          axisTick: {
            show: false
          },
          data: []
        }],
        yAxis: [{
          name: '',
          nameTextStyle: {
            color: '#999B9E',
            fontSize: 12,
            padding: 0
          },
          min: 0,
          splitLine: {
            show: true,
            lineStyle: {
              color: '#192a4411'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              // color: '#23365311'
              color: 'rgba(16,137,255,0.1)'
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#999B9E',
              padding: 0
            },
            formatter: function(value) {
              if (value === 0) {
                return value
              }
              return value
            }
          },
          axisTick: {
            // show: false
            alignWithLabel: true
          }
        }],
        series: [{
          name: '报警次数:',
          type: 'line',
          smooth: true,
          // showSymbol: false,
          symbolSize: 7,
          zlevel: 3,
          lineStyle: {
            normal: {
              color: '#1089FF',
              shadowBlur: 3,
              shadowColor: '#14b1eb66',
              shadowOffsetY: 0
            }
          },
          // markPoint: {
          //   label: {
          //     normal: {
          //       textStyle: {
          //         color: '#fff'
          //       }
          //     }
          //   },
          //   data: [{
          //     type: 'max',
          //     name: '最大值'
          //   }, {
          //     type: 'min',
          //     name: '最小值'
          //   }]
          // },
          areaStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [{
                  offset: 0,
                  color: '#1089FF'
                },
                {
                  offset: 1,
                  color: '#14b1eb00'
                }],
                false
              ),
              shadowColor: '#14b1eb11',
              shadowBlur: 10
            }
          },
          data: []
        }]
      },
      todayList: [],
      type: '',
      chartLoading: false,
      dataList: [],
      statisticsList:[]
    }
  },
  created(){
    this.getStatisticsList()
    this.getHositoryEchart()
    this.getTodayList()
    this.$nextTick(() => {
      // this.options.xAxis[0].data = []
      // this.options.series[0].data = []
      // this.options.graphic[0].children[0].style.text = ['没有找到您要查询的相关数据']
      // this.draw()
    })
  },
  computed: {
    optionHover() {
      return {
        hoverStop: true, // 鼠标悬停停止滚动
        direction: [1, 0][0], // 向下/上滚动
        step: 0.4, // 滚动速度
        // singleHeight: 20, // 滚动单行
        // waitTime:2500 // 单行停顿时间
      }
    }
  },
  methods:{
    resetDatas(){
      this.getStatisticsList()
      this.getHositoryEchart()
      this.getTodayList()
    },
    closeRightCons(){
      this.$emit('closeRightCons',false)
    },
    getStatisticsList() {
      //获取当天履职列表
      this.request.postParamsData('/front/device/deviceOverallStatistics', {
        type: this.typeId
      }).then(res => {
        console.log(res)
        if (res.code === 200) {
          let obj = { ...res.data }
          let arry = []
          Object.keys(obj).forEach(function(key){
            // console.log(key,obj[key])
            if (key === 'onlineCount') {
              arry.push({name:'在线设备',num:obj[key],img:require('../../../assets/img/deviceGas/deviceOnline.png'),imgBg:require('../../../assets/img/deviceGas/deviceOnlineBg.png')})
            } else if(key === 'totalCount'){
              arry.push({name:'设备总数',num:obj[key],img:require('../../../assets/img/deviceGas/deviceAllcount.png'),imgBg:require('../../../assets/img/deviceGas/deviceAllcountBg.png')})
            } else if(key === 'installCount'){
              arry.push({name:'今日新增',num:obj[key],img:require('../../../assets/img/deviceGas/deviceAdd.png'),imgBg:require('../../../assets/img/deviceGas/deviceAddBg.png')})
            } else if(key === 'alarmCount'){
              arry.push({name:'今日报警',num:obj[key],img:require('../../../assets/img/deviceGas/deviceAlarm.png'),imgBg:require('../../../assets/img/deviceGas/deviceAlarmBg.png')})
            } else if(key === 'faultCount'){
              arry.push({name:'今日故障',num:obj[key],img:require('../../../assets/img/deviceGas/deviceFault.png'),imgBg:require('../../../assets/img/deviceGas/deviceFaultBg.png')})
            }
          })
          this.statisticsList = [ ...arry ]
        } else if (res.code === 500) {
          this.statisticsList = []
          this.msg.warn(res.msg)
        }
      })
      .catch(error => {
        console.log(error)
      })
    },
    // 历史报警走势
    getHositoryEchart(){
      this.chartLoading = true
      this.request.postParamsData('/front/alarm/record/getAlarmCountStatisticsByDay', {
        days: 7,
        type: this.typeId
      }).then(res => {
        // console.log(res);
        this.chartLoading = false
        if (res.code === 200) {
          if (res.data) {
            this.dataList = [...res.data]
            if(this.dataList.length==0){
              this.options.xAxis[0].data = []
              this.options.series[0].data = []
              this.options.graphic[0].children[0].style.text = ['没有找到您要查询的相关数据']
            }else{
              const xData = []
              const yData = []
              this.dataList.forEach(item => {
                xData.push(item.day)
                yData.push(item.alarmCount)
              })
              this.options.xAxis[0].data = xData
              this.options.series[0].data = yData
              this.options.graphic[0].children[0].style.text = ['']
            }
          } else {
            this.options.xAxis[0].data = []
            this.options.series[0].data = []
            this.options.graphic[0].children[0].style.text = ['没有找到您要查询的相关数据']
          }
        } else if (res.code === 500) {
          this.msg.warn(res.msg)
          this.dataList = []
          this.options.xAxis[0].data = []
          this.options.series[0].data = []
          this.options.graphic[0].children[0].style.text = ['没有找到您要查询的相关数据']
        }
        this.draw()
      })
      .catch(error => {
        console.log(error)
      })
    },
    getTodayList() {
      //获取最新报警
      this.request.postParamsData('/front/alarm/record/getNewestAlarms', {
        minutes: 1440,
        type: this.typeId
      }).then(res => {
        console.log(res);
        if (res.code === 200) {
          this.todayList = res.data?res.data:[]
        } else if (res.code === 500) {
          this.todayList = []
          this.msg.warn(res.msg)
        }
      })
      .catch(error => {
        console.log(error)
      })
    },
    draw() {
      this.chart = this.$refs.chartLine.chart
      this.chart.setOption(this.options)
    }
  }
}
</script>

<style lang="scss" scoped>
.deviceRightCons{
  width: 100%;
  height: 100%;
  .topWarp{
    width: 100%;
    height: 60px;
    padding: 0 20px;
    overflow: hidden;
    box-sizing: border-box;
    background: #F7FBFF;
    .title{
      float: left;
      font-size: 0;
      overflow: hidden;
      span{
        float: left;
        font-size: 16px;
        font-weight: 600;
        color: #33383E;
        line-height: 60px;
      }
      i{
        margin:23px 0 0 10px;
        float: left;
        width: 14px;
        height: 14px;
        cursor: pointer;
        img{
          width: 100%;
          height: 100%;
          vertical-align: unset;
        }
      }
      .img1{
        display: block;
      }
      .img2{
        display: none;
      }
      &:hover{
        .img1{
          display: none;
        }
        .img2{
          display: block;
        }
      }
    }
    .closeRight{
      float: right;
      overflow: hidden;
      width: 102px;
      height: 34px;
      background: #FFFFFF;
      border-radius: 2px;
      margin-top: 13px;
      cursor: pointer;
      i{
        float: left;
        width: 16px;
        height: 16px;
        margin:9px 10px 0;
        img{
          width: 100%;
          height: 100%;
          vertical-align: unset;
        }
      }
      span{
        margin-top: 10px;
        float: left;
        font-size: 14px;
        line-height: 14px;
        font-weight: 500;
        color: #87C4FF;
      }
    }
  }
  .common{
    box-sizing: border-box;
    padding:10px 30px 0;
    width: 100%;
    .container{
      width: 100%;
      height: 100%;
      background: #fff;
      h3{
        color:#33383E;
        padding-left: 10px;
        font-size: 14px;
        line-height: 28px;
      }
      .tBox {
        height: 100%;
        .thTitle {
          padding: 0;

          dl {
            overflow: hidden;
            margin-top: 10px;
            background: #F4F7FA;

            dd {
              float: left;
              height: 34px;
              line-height: 34px;
              width: 23%;
              text-align: center;
              font-size: 14px;
              color:#33383E;
              &:nth-child(1){
                width: 8%;
              }
            }
          }
        }
        .seamless-warp {
          height:80%;
          overflow: hidden;
          font-size: 14px;
          padding: 0;
          text-align: center;
          li {
            height: 34px;
            line-height: 34px;
            overflow: hidden;
          }

          span {
            float: left;
            width: 23%;
            height: 100%;
            color: #666A6F;
          }

          .num {
            width: 8%;
          }
          .warnContent{
            color:#F43300;
          }
          .title {
            font-size: 14px;
            border: none;
            padding: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }
  .top{
    height: 97px;
    padding:15px 25px 0;
    ul{
      width: 100%;
      height: 100%;
      overflow: hidden;
      li{
        width: 20%;
        height: 100%;
        float: left;
        box-sizing: border-box;
        padding:0 5px;
        .tabItem{
          width: 100%;
          background: #fff;
          height: 100%;
          color: #fff;
          box-sizing: border-box;
          padding: 12px;
          border-radius: 3px;
          .lCons{
            width: 100%;
            overflow: hidden;
            .deviceImg{
              float: left;
              width: 14px;
              height: 14px;
              margin-right: 5px;
              img{
                width: 100%;
                height: 100%;
              }
            }
            .lName{
              float: left;
              width: 80px;
              font-size: 14px;
              line-height: 20px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-family: AlibabaPuHuiTi-Medium;
            }
          }
          .rCons{
            width: 100%;
            .num{
              font-size: 32px;
              line-height: 41px;
              letter-spacing: 1px;
              font-family: GoogleSans-Bold;
            }
          }
        }
      }
    }
  }
  .middle{
    width: 100%;
    height: calc(55% - 162px);
    .chartShow{
      width: 100%;
      height: calc(100% - 28px);
    }
  }
  .bottom{
    height: 45%;
    padding-bottom: 10px;
    position: relative;
    .noData{
      position: absolute;
      top: 55%;
      left: 50%;
      margin-left: -25px;
      span{
        font-size: 16px;
        color: #ccc;
      }
    }
  }
}
</style>